import React, { useEffect } from "react";
import PageTitle from "../../shared/PageTitle";
import { ActionTypes } from "../../redux/ActionTypes";
import { useDispatch } from "react-redux";
import { MenuId } from "../../Constants";

const Home = () => {
  const pageName = "Dashboard";
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: MenuId.DASHBOARD });
    window.history.replaceState({}, document.title);
  }, [dispatch]);

  return (
    <>
      <PageTitle title={pageName} />
      <div className="container gp-container">
        {/* <div className="col-md-6 announcement-container">
          <h1>Announcement</h1>
          <ul className="announcement-list">
            <hr />
            <h2>2025 Q1 CONTEST !!!</h2>
            <br />
            <img
              title="gpfa portal"
              src={`${process.env.PUBLIC_URL}/images/ContestQ12025.JPG`}
              className="contest-image"
            />
          </ul>
          <br />
        </div> */}
        <div className="col-md-6">
          <h1>Entries</h1>
          <br />
          <div
            className="resource-form"
            onClick={() => {
              window.open("https://forms.gle/HZmy7WwREsCBxjzd6", "_blank");
            }}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <img
                      alt="Production Entry Form"
                      src={`${process.env.PUBLIC_URL}/images/googleForm.png`}
                      className="form-icon"
                    />
                  </td>
                  <td className="form-text">
                    <div className="form-title">Production Entry Form</div>
                    <div>
                      <p className="form-subtitle">Google Form</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div
            className="resource-form"
            onClick={() => {
              window.open("https://forms.gle/FtjAL5Fe49uHr5Pn9", "_blank");
            }}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <img
                      alt="Getting Appointed Form"
                      src={`${process.env.PUBLIC_URL}/images/googleFormA.png`}
                      className="form-icon"
                    />
                  </td>
                  <td className="form-text">
                    <div className="form-title">Getting Appointed Form</div>
                    <div>
                      <p className="form-subtitle">Google Form</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;